import * as React from "react";
import {ActiveStyle,InactiveStyle} from "./header-megamenu-dropdown";
import styled from "styled-components";

/** HeaderMegamenuDropdownItemMenuElementNested */

interface HeaderMegamenuDropdownItemMenuElementNestedProps {
  menuElement: HeaderMegamenuDropdownItemMenuElementData
  handleHeaderMenuElementSelection: (elementLinkTo: string) => any
}

interface HeaderMegamenuDropdownItemMenuElementNestedState {
  active: boolean
}

class HeaderMegamenuDropdownItemMenuElementNested extends React.Component<HeaderMegamenuDropdownItemMenuElementNestedProps,HeaderMegamenuDropdownItemMenuElementNestedState> {

  constructor(props: HeaderMegamenuDropdownItemMenuElementNestedProps) {
    super(props);
    this.state = {
      active: false
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  onMouseEnter() {
    this.setState({active: true});
  }

  onMouseLeave() {
    this.setState({active: false});
  }

  render() {
    const {menuElement,handleHeaderMenuElementSelection} = this.props;
    const {active} = this.state;

    // ELEMENT VARIABLES
    const hasChildren: boolean = menuElement.elementChildren && menuElement.elementChildren.length > 0;
    const linkProps: any = {
      onClick: () => !hasChildren && !menuElement.elementLinkOpenInNewTab ? handleHeaderMenuElementSelection(menuElement.elementLinkTo) : undefined,
      target: menuElement.elementLinkOpenInNewTab ? "_blank" : "_self",
      rel: menuElement.elementLinkNoFollow ? "nofollow" : undefined,
      href: menuElement.elementLinkOpenInNewTab ? menuElement.elementLinkTo : undefined
    };

    return (
      <HeaderMegamenuDropdownItemMenuElementNestedWrapper onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
        <a {...linkProps} className="menu-element-nested">
          {menuElement.elementName}
          {hasChildren && <span className="indicator"><i className="fa fa-angle-right"></i></span>}
        </a>

        {hasChildren &&
          <ul className="dropdown" style={active ? ActiveStyle : InactiveStyle}>
            {menuElement.elementChildren.map((element: HeaderMegamenuDropdownItemMenuElementData, index: number) =>
              <HeaderMegamenuDropdownItemMenuElementNested
                key={index}
                menuElement={element}
                handleHeaderMenuElementSelection={handleHeaderMenuElementSelection}
              />
            )}
          </ul>
        }

      </HeaderMegamenuDropdownItemMenuElementNestedWrapper>
    )
  }

}

/** STYLES => HeaderMegamenuDropdownItemMenuElementNested */

const HeaderMegamenuDropdownItemMenuElementNestedWrapper = styled.li`
  a.menu-element-nested {
    text-transform: none !important;
    height: auto !important;
    line-height: 29px !important;
  }
`;

/** HeaderMegamenuDropdownItemMenuElement */
interface HeaderMegamenuDropdownItemMenuElementProps {
  elements: HeaderMegamenuDropdownItemMenuElementData[]
  handleHeaderMenuElementSelection: (elementLinkTo: string) => any
}

const HeaderMegamenuDropdownItemMenuElement = (props: HeaderMegamenuDropdownItemMenuElementProps) => {
  const {elements,handleHeaderMenuElementSelection} = props;
  return (
    <ul className="dropdown" style={ActiveStyle}>
      {elements.map((element: HeaderMegamenuDropdownItemMenuElementData, index: number) =>
        <HeaderMegamenuDropdownItemMenuElementNested
          key={index}
          menuElement={element}
          handleHeaderMenuElementSelection={handleHeaderMenuElementSelection}
        />
      )}
    </ul>
  )

};

export default HeaderMegamenuDropdownItemMenuElement


// WEBPACK FOOTER //
// ./src/layouts/header/header-megamenu-dropdown-item-menu-element.tsx